// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sticky-search[data-v-db62226c] {\n  position: sticky;\n  z-index: 1;\n  top: 64px;\n  padding-bottom: 0;\n  background: white;\n}\n", ""]);
// Exports
module.exports = exports;
